/**
 * useGenerationStats Hook
 *
 * Lädt durchschnittliche Generierungszeiten für Progress-Estimation.
 * Nutzt TanStack Query mit 5-minütigem Cache.
 */

import { useQuery } from '@tanstack/react-query';
import { getGenerationTimeStats } from '@/lib/api/statistics';

/**
 * Query key factory für Generation Statistics.
 */
export const generationStatsKeys = {
  all: ['generation-stats'] as const,
  time: () => [...generationStatsKeys.all, 'time'] as const,
};

/**
 * Hook zum Laden der durchschnittlichen Generierungszeit.
 *
 * @returns Query mit average_duration (Sekunden), sample_size, und unit
 */
export function useGenerationStats() {
  return useQuery({
    queryKey: generationStatsKeys.time(),
    queryFn: getGenerationTimeStats,
    staleTime: 5 * 60 * 1000, // 5 Minuten Cache
    retry: 1, // Bei Fehler nur 1x retry (z.B. wenn keine Daten vorhanden)
  });
}

export default useGenerationStats;
